import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import CalendarDialog from "../../calendarDialog/CalendarDialog";
import UpperCaseText from "../../../../../utils/UpperCaseText";
import {
  BNPP,
  FINANCE,
  FINANCE_OPTIONS,
  OFFLINEFINANCE,
  PRIVATE_LEASE,
} from "../../../../../common/Constants";
import CheckBox from "../../../../../shared/checkBox/CheckBox";
import checkboxStyles from "../../../../../shared/checkBox/CheckBox.module.scss";
import RegistrationNumberDialog from "./registrarionNumberDialog/RegistrationNumberDialog";
import TermsDialog from "../../../../../shared/termsDialog/TermsDialog";
import styles from "./FinanceOptions.module.scss";
import CalendarDialogWithOutCheckBox from "../../calendarDialog/CalenderDialogWithoutCheckBox";
import CapitalizeText from "../../../../../utils/CapitalizeText";
import HasPermissionTo from "../../../../../common/HasPermissionTo";
import LowerCaseText from "../../../../../utils/LowerCaseText";
import CustomerReservationsClient from "../../../../../shared/clients/CustomerReservationsClient";
import FileEncoder from "../../../../../utils/FileEncoder";
import UiDateUtils from "../../../../../utils/UiDateUtils";

import Error from "../../../../../imgs/error/error.png";
import {
  AGENT,
  IS_AGENT_DEALERTYPE,
  IS_BRITAIN_MARKET,
} from "../../../../../utils/EmpUtil";
import CheckBoxDialog from "../../../../../shared/checkBoxDialog/CheckBoxDialog";

const ItemDetails = ({ date, description }) => {
  return (
    <div className={styles.info}>
      {date ? (
        <span className={styles.paymentInfo}>
          {UiDateUtils.formattedDate(date)}
        </span>
      ) : (
        <span className={styles.emptyDate} />
      )}
      {description}
    </div>
  );
};

class FinanceOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openRegistrationNumberDialog: false,
      openDealerInvoiceDialog: false,
      openDeliveryCertificateDialog: false,
    };
    this.hasCompletedRegistrationNumber = false;
    this.hasUploadedDealerInvoice = false;
    this.hasUploadedDeliveryCertificate = false;
    this.hasCompletedFinanceContract = false;
    this.hasCompletedDownPayment = false;
    this.hasCompletedFinancePayment = false;
    this.eSignedDate = null;
    this.eSignedWindowDate = null;
    this.expiryDate = null;
    this.completedDate = null;
    this.hasCompletedPaymentWindow = false;
    this.hasCompletedFullPayment = false;

    this.canEditPaymentMethod =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "paymentMethod:write"
      );
    this.canOpenPaymentWindow =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "paymentWindow:write"
      );
    this.canEditRegistrationNumber =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "registrationNumber:write"
      );
    this.contractPrefix =
      LowerCaseText(this.props.paymentType) === PRIVATE_LEASE
        ? "PMPrivateLeaseContract"
        : "PMFinanceContract";
    this.paymentPrefix =
      LowerCaseText(this.props.paymentType) === PRIVATE_LEASE
        ? "PMPrivateLeasePayment"
        : "PMFinancePayment";
    this.downPaymentPrefix =
      LowerCaseText(this.props.paymentType) === PRIVATE_LEASE
        ? "PMPrivateLeaseCustomerDownPayment"
        : "PMCustomerDownPayment";

    this.showFullFinanceOptions =
      IS_AGENT_DEALERTYPE(this.props.dealerType) &&
      LowerCaseText(this.props.paymentType) === FINANCE;
  }

  onConfirmFinancePaymentWindow = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const formattedDate = UiDateUtils.formatDateYYYYMMDD(year, month, day);
    this.saveFinanceOption(
      UiDateUtils.saveDateFormat(formattedDate),
      "paymentwindowopen"
    );
    this.openPaymentWindow();
  };

  handleRegistrationNumberDialog = () => {
    this.setState((prevState) => ({
      openRegistrationNumberDialog: !prevState.openRegistrationNumberDialog,
    }));
  };
  handleDealerInvoiceDialog = () => {
    this.setState((prevState) => ({
      openDealerInvoiceDialog: !prevState.openDealerInvoiceDialog,
    }));
  };
  handleConsumerDownPayment = () => {};

  toggleDeliveryCertificateDialog = () => {
    this.setState((prevState) => ({
      openDeliveryCertificateDialog: !prevState.openDeliveryCertificateDialog,
    }));
  };

  checkHasCompletedPreviousActions() {
    const customerReservation = this.props.customerReservation;

    this.hasCompletedRegistrationNumber =
      customerReservation.registrationDetails &&
      customerReservation.registrationDetails.registrationNumber !== null &&
      customerReservation.registrationDetails.registrationDate !== null;
    this.hasUploadedDealerInvoice =
      customerReservation.uploadDealerInvoiceData &&
      customerReservation.uploadDealerInvoiceData.dealerActionDate !== null;

    this.hasUploadedDeliveryCertificate =
      customerReservation.uploadDeliveryCertificateData &&
      customerReservation.uploadDeliveryCertificateData.dealerActionDate !==
        null;
    this.hasCompletedDownPayment =
      customerReservation.downPaymentPaidData &&
      customerReservation.downPaymentPaidData.paymentDate !== null;
    this.hasCompletedFinancePayment =
      customerReservation.finalPaymentConfirmedData &&
      customerReservation.finalPaymentConfirmedData.dealerAcceptedDate !== null;
    this.financeContractData(this.props.customerReservation.paymentDescription);
    this.hasCompletedPaymentWindow =
      customerReservation.paymentWindowOpenedData &&
      customerReservation.paymentWindowOpenedData.dealerAcceptedDate &&
      customerReservation.paymentWindowOpenedData.dealerActionUserId;
    this.hasCompletedFullPayment = !!(
      customerReservation.finalPaymentConfirmedData &&
      customerReservation.finalPaymentConfirmedData.dealerAcceptedDate &&
      customerReservation.finalPaymentConfirmedData.dealerActionUserId
    );
  }

  financeContractData = (paymentDesc) => {
    if (
      IS_BRITAIN_MARKET(this.props.selectedMarket) &&
      LowerCaseText(this.props.paymentType) === FINANCE
    ) {
      paymentDesc &&
        paymentDesc.length > 0 &&
        paymentDesc.forEach((item) => {
          if (UpperCaseText(item.status) === FINANCE_OPTIONS.SIGNING) {
            this.eSignedWindowDate = item.date;
            const dateArray = item.date.split("-");
            const dateObject = new Date(
              dateArray[1] + "-" + dateArray[0] + "-" + dateArray[2]
            );
            const monthDateObject = new Date(
              dateObject.setMonth(dateObject.getMonth() + 1)
            );
            const expiryDate = new Date(
              monthDateObject.setDate(monthDateObject.getDate() - 1)
            );
            const year = expiryDate.getFullYear();
            const month = (1 + expiryDate.getMonth())
              .toString()
              .padStart(2, "0");
            const day = expiryDate.getDate().toString().padStart(2, "0");
            this.expiryDate = day + "/" + month + "/" + year;
          }
          if (UpperCaseText(item.status) === FINANCE_OPTIONS.SIGNED) {
            this.eSignedDate = item.date;
          }
          if (UpperCaseText(item.status) === FINANCE_OPTIONS.COMPLETED) {
            this.completedDate = item.date;
          }
        });
      this.hasCompletedFinanceContract = this.eSignedDate !== null;
      this.hasCompletedFinancePayment = this.completedDate !== null;
    } else {
      this.hasCompletedFinanceContract =
        this.props.customerReservation.contractSignedData &&
        this.props.customerReservation.contractSignedData.dealerAcceptedDate !==
          null;
      this.hasCompletedFinancePayment =
        this.props.customerReservation.finalPaymentConfirmedData &&
        this.props.customerReservation.finalPaymentConfirmedData
          .dealerAcceptedDate !== null;
    }
  };
  hasCompletedPreviousOption = (id) => {
    let previousStep = null;
    const options = FINANCE_OPTIONS[UpperCaseText(this.props.selectedMarket)];
    options &&
      options.forEach((item) => {
        if (item.key === id) {
          if (!item.hasPrevious) {
            previousStep = false;
          } else {
            previousStep = item.previousKey;
          }
        }
      });
    switch (previousStep) {
      case true:
        return true;
      case "registrationNumber":
        return !this.hasCompletedRegistrationNumber;
      case "uploadDealerInvoice":
        return !this.hasUploadedDealerInvoice;
      case "uploadDeliveryCertificate":
        return !this.hasUploadedDeliveryCertificate;
      case "financeContract":
        return !this.hasCompletedFinanceContract;
      case "customerDownPayment":
        return !this.hasCompletedDownPayment;
      case "financePayment":
        return !this.hasCompletedFinancePayment;
      case "openPaymentWindow":
        return !this.hasCompletedPaymentWindow;
      case "customerFullPayment":
        return !this.hasCompletedFullPayment;
      default:
        return previousStep;
    }
  };

  uploadInvoice = (dealerId, file) => {
    const proposalNumber =
      this.props.customerReservation &&
      this.props.customerReservation.proposalNumber;

    this.props.hideOrShow(true);

    new FileEncoder().encode(file).then((data) => {
      const dealerInvoiceRequest = {
        dealerAction: "uploaddealerinvoice",
        token: this.props.user.token,
        commonIds: this.props.user.dealerId,
        userId: this.props.user.userId,
        fileName: file.name,
        fileData: data,
        dealerId: this.props.customerReservation.dealerId,
        fileType: "pdf",
        orderId: this.props.reservationId,
      };
      CustomerReservationsClient.uploadFinancialDocument(
        proposalNumber,
        dealerInvoiceRequest
      )
        .catch(() => {})
        .finally(() => {
          this.props.hideOrShow(false);
          this.handleDealerInvoiceDialog();
          this.props.refreshOrderDetails();
        });
    });
  };

  uploadDeliveryCertificate = (dealerId, file) => {
    const proposalNumber =
      this.props.customerReservation &&
      this.props.customerReservation.proposalNumber;

    this.props.hideOrShow(true);

    new FileEncoder()
      .encode(file)
      .then((encodedFile) => {
        const deliveryCertificateRequest = {
          dealerAction: "uploaddeliverycertificate",
          token: this.props.user.token,
          commonIds: this.props.user.dealerId,
          userId: this.props.user.userId,
          file: encodedFile,
          fileName: file.name,
          fileType: "pdf",
          dealerId: this.props.customerReservation.dealerId,
          orderId: this.props.reservationId,
        };

        CustomerReservationsClient.uploadFinancialDocument(
          proposalNumber,
          deliveryCertificateRequest
        )
          .then(() => {
            this.toggleDeliveryCertificateDialog();
          })
          .catch(() => {});
      })
      .catch(() => {})
      .finally(() => {
        this.props.refreshOrderDetails();

        this.props.hideOrShow(false);
      });
  };

  saveFinanceOption = (acceptedDate, type) => {
    this.props.handleUpdateOrder(type, acceptedDate);
  };

  saveRegistrationData = (number, dateFce, dateSap) => {
    this.props.updateRegistrationData(
      number,
      dateFce,
      dateSap,
      this.props.customerReservation.vinNumber,
      FINANCE
    );
    this.handleRegistrationNumberDialog();
  };

  isFinanceOpenPaymentDisabled = () => {
    return LowerCaseText(this.props.paymentType) === FINANCE
      ? this.hasCompletedPreviousOption("openPaymentWindow") ||
          this.hasCompletedPaymentWindow ||
          !this.canOpenPaymentWindow
      : this.hasCompletedPaymentWindow;
  };

  isFinanceFullPaymentEnabled = () => {
    return LowerCaseText(this.props.paymentType) === FINANCE
      ? this.hasCompletedPreviousOption("customerFullPayment") ||
          this.hasCompletedFullPayment ||
          !this.canEditPaymentMethod
      : this.hasCompletedFullPayment;
  };

  openPaymentWindow = () => {
    this.setState((prevState) => ({
      openPaymentWindow: !prevState.openPaymentWindow,
    }));
  };

  render() {
    this.checkHasCompletedPreviousActions();
    const dealerType = this.props.customerReservation.dealerType;
    const herculesBNPPFinancePaymentMethod =
      dealerType === AGENT &&
      UpperCaseText(this.props.customerReservation.financeProvider) === BNPP;
    return (
      <div>
        <div>
          {/*Registration Number will be only for the online approved orders*/}
          <HasPermissionTo
            perform={["financeRegistrationNumber:view"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={LowerCaseText(this.props.paymentType) === FINANCE}
            render={() => {
              return (
                <div data-testId="registrationNumber">
                  <div className={styles.rowContainer}>
                    <CheckBox
                      id="registration_Number_id"
                      checked={this.hasCompletedRegistrationNumber}
                      isDisabled={
                        this.hasCompletedPreviousOption("registrationNumber") ||
                        this.hasCompletedRegistrationNumber ||
                        !this.canEditRegistrationNumber
                      }
                      label={this.props.t("PMRegistrationNumber.title")}
                      onChange={this.handleRegistrationNumberDialog}
                      textClass={
                        this.hasCompletedPreviousOption("registrationNumber") ||
                        this.hasCompletedRegistrationNumber ||
                        !this.canEditRegistrationNumber
                          ? this.hasCompletedRegistrationNumber
                            ? checkboxStyles.boldLabel
                            : checkboxStyles.disabledLabel
                          : checkboxStyles.boldLabel
                      }
                    />
                  </div>
                  {this.hasCompletedRegistrationNumber && (
                    <>
                      <ItemDetails
                        date={
                          this.props.customerReservation.registrationDetails
                            .dealerActionDate
                        }
                        description={
                          <>
                            <span className={styles.acceptGreen}>
                              {this.props.t("PMRegistrationNumber.recordedBy")}
                            </span>
                            <span className={styles.detailsText}>
                              &nbsp;
                              {CapitalizeText(
                                this.props.customerReservation
                                  .registrationDetails.dealerActionUserId
                              )}
                            </span>
                          </>
                        }
                      />
                      <ItemDetails
                        description={
                          <>
                            <span className={styles.dateText}>
                              {this.props.t("PMRegistrationNumber.regNumber")}
                            </span>
                            <span className={styles.detailsText}>
                              {
                                this.props.customerReservation
                                  .registrationDetails.registrationNumber
                              }
                            </span>
                          </>
                        }
                      />
                      <ItemDetails
                        description={
                          <>
                            <span className={styles.dateText}>
                              {this.props.t(
                                "PMRegistrationNumber.dateRegistered"
                              )}
                            </span>
                            <span className={styles.detailsText}>
                              {UiDateUtils.formattedDate(
                                this.props.customerReservation
                                  .registrationDetails.registrationDate
                              )}
                            </span>
                          </>
                        }
                      />
                    </>
                  )}
                </div>
              );
            }}
          />
          {/*Upload Dealer Invoice will be only for the online approved orders*/}
          <HasPermissionTo
            perform={["financeUploadDealerInvoice:view"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={LowerCaseText(this.props.paymentType) === FINANCE}
            render={() => {
              return (
                <div data-testid="dealerInvoice">
                  <div className={styles.rowContainer}>
                    <CheckBox
                      id="dealer_Invoice_id"
                      checked={this.hasUploadedDealerInvoice}
                      isDisabled={
                        this.hasCompletedPreviousOption(
                          "uploadDealerInvoice"
                        ) ||
                        this.hasUploadedDealerInvoice ||
                        !this.canEditPaymentMethod
                      }
                      label={this.props.t(
                        "PMDealerInvoice.uploadDealerInvoice"
                      )}
                      onChange={this.handleDealerInvoiceDialog}
                      textClass={
                        this.hasCompletedPreviousOption(
                          "uploadDealerInvoice"
                        ) ||
                        this.hasUploadedDealerInvoice ||
                        !this.canEditPaymentMethod
                          ? this.hasUploadedDealerInvoice
                            ? checkboxStyles.boldLabel
                            : checkboxStyles.disabledLabel
                          : checkboxStyles.boldLabel
                      }
                    />
                    {this.hasUploadedDealerInvoice && !this.eSignedDate && (
                      <div
                        className={styles.updateText}
                        onClick={this.handleDealerInvoiceDialog}
                      >
                        {this.props.t("PaymentMethod.update")}
                      </div>
                    )}
                  </div>
                  {this.hasUploadedDealerInvoice && (
                    <ItemDetails
                      date={
                        this.props.customerReservation.uploadDealerInvoiceData
                          .dealerActionDate
                      }
                      description={
                        <>
                          <span className={styles.acceptGreen}>
                            {this.props.t("PMDealerInvoice.invoiceUploaded")}
                          </span>
                          <span className={styles.detailsText}>
                            &nbsp;
                            {CapitalizeText(
                              this.props.customerReservation
                                .uploadDealerInvoiceData.dealerActionUserId
                            )}
                          </span>
                        </>
                      }
                    />
                  )}
                </div>
              );
            }}
          />

          {/*Upload DELIVERY CERTIFICATE option is only for FRA market and ONLINE approved orders*/}
          <HasPermissionTo
            perform={["financeUploadDeliveryCertificate:view"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={LowerCaseText(this.props.paymentType) === FINANCE}
            render={() => {
              return (
                <div data-testid="deliveryCertificateTestId">
                  <div className={styles.rowContainer}>
                    <CheckBox
                      id="deliveryCertificateCheckboxId"
                      checked={this.hasUploadedDeliveryCertificate}
                      isDisabled={
                        this.hasCompletedPreviousOption(
                          "uploadDeliveryCertificate"
                        ) ||
                        this.hasUploadedDeliveryCertificate ||
                        !this.canEditPaymentMethod
                      }
                      label={this.props.t(
                        "PMDeliveryCertificate.checkBoxCaption"
                      )}
                      onChange={this.toggleDeliveryCertificateDialog}
                      textClass={
                        this.hasCompletedPreviousOption(
                          "uploadDeliveryCertificate"
                        ) ||
                        this.hasUploadedDeliveryCertificate ||
                        !this.canEditPaymentMethod
                          ? this.hasUploadedDeliveryCertificate
                            ? checkboxStyles.boldLabel
                            : checkboxStyles.disabledLabel
                          : checkboxStyles.boldLabel
                      }
                    />
                  </div>
                  {this.hasUploadedDeliveryCertificate && (
                    <ItemDetails
                      date={
                        this.props.customerReservation
                          .uploadDeliveryCertificateData.dealerActionDate
                      }
                      description={
                        <>
                          <span className={styles.acceptGreen}>
                            {this.props.t(
                              "PMDeliveryCertificate.certificateUploaded"
                            )}
                          </span>
                          <span className={styles.detailsText}>
                            &nbsp;
                            {CapitalizeText(
                              this.props.customerReservation
                                .uploadDeliveryCertificateData
                                .dealerActionUserId
                            )}
                          </span>
                        </>
                      }
                    />
                  )}
                </div>
              );
            }}
          />
          {/*Finance contract will be for the both offline and online  approved orders*/}
          <HasPermissionTo
            perform={["financeContract:view"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={
              !herculesBNPPFinancePaymentMethod &&
              (LowerCaseText(this.props.paymentType) === OFFLINEFINANCE ||
                FINANCE_OPTIONS.ONLINE_APPROVED_MARKETS.includes(
                  UpperCaseText(this.props.selectedMarket)
                ))
            }
            render={() => {
              return (
                <div data-testId="financeContract">
                  <div className={styles.rowContainer}>
                    <CalendarDialog
                      {...this.props}
                      id="financeContract"
                      saveCalendarDate={this.saveFinanceOption}
                      todayDate={this.props.customerReservation.todayDate}
                      type={FINANCE_OPTIONS.FINANCE_CONTRACT}
                      checkBoxText={this.props.t(
                        `${this.contractPrefix}.financeContract`
                      )}
                      isDisabled={
                        LowerCaseText(this.props.paymentType) === FINANCE
                          ? this.hasCompletedPreviousOption(
                              "financeContract"
                            ) ||
                            this.hasCompletedFinanceContract ||
                            IS_BRITAIN_MARKET(this.props.selectedMarket) ||
                            !this.canEditPaymentMethod
                          : this.hasCompletedFinanceContract ||
                            !this.canEditPaymentMethod
                      }
                      isChecked={this.hasCompletedFinanceContract}
                      hasMaxDate={true}
                      dialogTitle={this.props.t(
                        `${this.contractPrefix}.dateSigned`
                      )}
                      dialogDescription={this.props.t(
                        `${this.contractPrefix}.dialogDescription`
                      )}
                    />
                  </div>
                  {this.hasUploadedDealerInvoice && (
                    <>
                      {this.eSignedWindowDate !== null && (
                        <ItemDetails
                          date={this.eSignedWindowDate}
                          description={
                            <div className={styles.flexDiv}>
                              <span className={styles.dateText}>
                                {this.props.t(
                                  `${this.contractPrefix}.eSignWindowOpen`
                                )}
                              </span>
                              {!this.eSignedDate && (
                                <>
                                  <span className={styles.warningRed}>
                                    {this.props.t(
                                      `${this.contractPrefix}.expiresOn`
                                    )}
                                  </span>
                                  <span className={styles.warningRed}>
                                    {this.expiryDate}
                                  </span>
                                  <img src={Error} className={styles.Error} />
                                </>
                              )}
                            </div>
                          }
                        />
                      )}

                      {this.hasCompletedFinanceContract &&
                        (this.expiryDate === null ? (
                          <ItemDetails
                            date={
                              this.props.customerReservation.contractSignedData
                                .dealerAcceptedDate
                            }
                            description={
                              <>
                                <span className={styles.acceptGreen}>
                                  {this.props.t("PMLeaseContract.eSigned")}
                                </span>
                                <span className={styles.detailsText}>
                                  {CapitalizeText(
                                    this.props.customerReservation
                                      .contractSignedData.dealerActionUserId
                                  )}
                                </span>
                              </>
                            }
                          />
                        ) : (
                          <ItemDetails
                            date={this.eSignedDate}
                            description={
                              <span className={styles.acceptGreen}>
                                {this.props.t("PMLeaseContract.eSignedOn")}
                              </span>
                            }
                          />
                        ))}
                    </>
                  )}
                  {this.hasCompletedFinanceContract &&
                    (LowerCaseText(this.props.paymentType) === OFFLINEFINANCE ||
                      !IS_BRITAIN_MARKET(this.props.selectedMarket)) && (
                      <ItemDetails
                        date={
                          this.props.customerReservation.contractSignedData
                            .dealerAcceptedDate
                        }
                        description={
                          <>
                            <span className={styles.acceptGreen}>
                              {this.props.t("PMLeaseContract.eSigned")}
                            </span>
                            <span className={styles.detailsText}>
                              &nbsp;
                              {CapitalizeText(
                                this.props.customerReservation
                                  .contractSignedData.dealerActionUserId
                              )}
                            </span>
                          </>
                        }
                      />
                    )}
                </div>
              );
            }}
          />
          {/*Consumer down payment will be for only online approved orders*/}
          <HasPermissionTo
            perform={["financeCustomerDownPayment:view"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={
              !herculesBNPPFinancePaymentMethod &&
              LowerCaseText(this.props.paymentType) === FINANCE
            }
            render={() => {
              return (
                <div data-testId="consumerDownPayment">
                  <div className={styles.downPaymentDiv}>
                    <CheckBox
                      id="consumerDownPayment_id"
                      checked={this.hasCompletedDownPayment}
                      isDisabled={true}
                      label={this.props.t(
                        `${this.downPaymentPrefix}.customerDownPayment`
                      )}
                      onChange={this.handleConsumerDownPayment}
                      textClass={
                        this.hasCompletedPreviousOption(
                          "customerDownPayment"
                        ) || this.hasCompletedDownPayment
                          ? this.hasCompletedDownPayment
                            ? checkboxStyles.boldLabel
                            : checkboxStyles.disabledLabel
                          : checkboxStyles.boldLabel
                      }
                    />

                    {this.hasCompletedFinanceContract &&
                      !this.hasCompletedDownPayment && (
                        <CalendarDialogWithOutCheckBox
                          {...this.props}
                          id="consumerDownPayment"
                          type={FINANCE_OPTIONS.CUSTOMER_DOWN_PAYMENT}
                          saveCalenderDate={this.saveFinanceOption}
                          todayDate={this.props.customerReservation.todayDate}
                          isDisabled={!this.canEditPaymentMethod}
                          hasMaxDate={true}
                          dialogTitle={this.props.t(
                            `${this.downPaymentPrefix}..dialogHeader`
                          )}
                          dialogDescription={this.props.t(
                            `${this.downPaymentPrefix}.dialogDescription`
                          )}
                          customInput={
                            <span className={styles.paidOffText}>
                              {this.props.t(
                                `${this.downPaymentPrefix}.paidOffline`
                              )}
                            </span>
                          }
                        />
                      )}
                  </div>
                  {this.hasCompletedDownPayment && (
                    <ItemDetails
                      date={
                        this.props.customerReservation.downPaymentPaidData
                          .paymentDate
                      }
                      description={
                        <span className={styles.acceptGreen}>
                          {this.props.customerReservation.downPaymentPaidData &&
                          this.props.customerReservation.downPaymentPaidData
                            .dealerActionDetails &&
                          this.props.customerReservation.downPaymentPaidData
                            .dealerActionDetails.dealerAcceptedDate !== null
                            ? this.props.t(
                                `${this.downPaymentPrefix}.payReceivedOff`
                              )
                            : this.props.t(
                                `${this.downPaymentPrefix}.payReceived`
                              )}
                        </span>
                      }
                    />
                  )}
                </div>
              );
            }}
          />
          {/*Finance payment will be for only online approved orders*/}
          <HasPermissionTo
            perform={["financePaymentCompletion:view"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={
              !herculesBNPPFinancePaymentMethod &&
              LowerCaseText(this.props.paymentType) === FINANCE
            }
            render={() => {
              return (
                <div data-testId="financePaymentConfirmation">
                  <div className={styles.rowContainer}>
                    <CheckBox
                      {...this.props}
                      id="financePayment"
                      checked={this.hasCompletedFinancePayment}
                      isDisabled={
                        IS_BRITAIN_MARKET(this.props.selectedMarket)
                          ? true
                          : this.hasCompletedPreviousOption("financePayment") ||
                            this.hasCompletedFinancePayment ||
                            !this.canEditPaymentMethod
                      }
                      label={this.props.t(
                        `${this.paymentPrefix}.financePayment`
                      )}
                      onChange={() => {
                        this.saveFinanceOption(
                          this.props.customerReservation.todayDate,
                          FINANCE_OPTIONS.FINANCE_PAYMENT_CONFIRMED
                        );
                      }}
                      textClass={
                        this.hasCompletedPreviousOption("financePayment") ||
                        this.hasCompletedFinancePayment
                          ? this.hasCompletedFinancePayment
                            ? checkboxStyles.boldLabel
                            : checkboxStyles.disabledLabel
                          : checkboxStyles.boldLabel
                      }
                    />
                  </div>
                  {this.hasCompletedFinancePayment &&
                    (this.completedDate !== null ? (
                      <ItemDetails
                        date={this.completedDate}
                        description={
                          <span className={styles.acceptGreen}>
                            {this.props.t(`${this.paymentPrefix}.completed`)}
                          </span>
                        }
                      />
                    ) : (
                      <ItemDetails
                        date={
                          this.props.customerReservation
                            .finalPaymentConfirmedData.dealerAcceptedDate
                        }
                        description={
                          <>
                            <span className={styles.acceptGreen}>
                              {this.props.t(
                                `${this.paymentPrefix}.paymentReceived`
                              )}
                            </span>
                            <span className={styles.detailsText}>
                              &nbsp;
                              {
                                this.props.customerReservation
                                  .finalPaymentConfirmedData.dealerActionUserId
                              }
                            </span>
                          </>
                        }
                      />
                    ))}
                </div>
              );
            }}
          />
          {this.showFullFinanceOptions && (
            <>
              <div data-testid="financeOpenPaymentWindow">
                <div className={styles.rowContainer}>
                  <CheckBox
                    id="openPaymentWindow"
                    isDisabled={
                      this.isFinanceOpenPaymentDisabled() ||
                      !this.canOpenPaymentWindow
                    }
                    label={this.props.t("PMOpenPaymentWindow.label")}
                    checked={this.hasCompletedPaymentWindow}
                    onChange={this.openPaymentWindow}
                    textClass={
                      this.hasCompletedPreviousOption(
                        "cashOpenPaymentWindow"
                      ) ||
                      this.hasCompletedPaymentWindow ||
                      !this.canOpenPaymentWindow
                        ? this.hasCompletedPaymentWindow
                          ? checkboxStyles.boldLabel
                          : checkboxStyles.disabledLabel
                        : checkboxStyles.boldLabel
                    }
                  />
                  {this.hasCompletedPaymentWindow && (
                    <ItemDetails
                      date={
                        this.props.customerReservation.paymentWindowOpenedData
                          .dealerAcceptedDate
                      }
                      description={
                        <>
                          <span className={styles.acceptGreen}>
                            {this.props.t("PMOpenPaymentWindow.released")}
                          </span>
                          <span className={styles.detailsText}>
                            {CapitalizeText(
                              this.props.customerReservation
                                .paymentWindowOpenedData.dealerActionUserId
                            )}
                          </span>
                        </>
                      }
                    />
                  )}
                </div>
              </div>
              <div data-testid="financeFullPayment ">
                <div className={styles.rowContainer}>
                  <CalendarDialog
                    {...this.props}
                    id="customerFullPayment"
                    saveCalendarDate={this.saveFinanceOption}
                    todayDate={this.props.customerReservation.todayDate}
                    type={FINANCE_OPTIONS.FINANCE_PAYMENT_CONFIRMED}
                    checkBoxText={this.props.t("PMCashPayment.financeLabel")}
                    isDisabled={
                      this.isFinanceFullPaymentEnabled() ||
                      !this.canEditPaymentMethod
                    }
                    isChecked={this.hasCompletedFullPayment}
                    hasMaxDate={true}
                    dialogTitle={this.props.t("PMCashPayment.dialogHeader")}
                    dialogDescription={this.props.t(
                      "PMCashPayment.dialogDescription"
                    )}
                  />
                  {this.hasCompletedFullPayment && (
                    <ItemDetails
                      date={
                        this.props.customerReservation.finalPaymentConfirmedData
                          .dealerAcceptedDate
                      }
                      description={
                        <>
                          <span className={styles.acceptGreen}>
                            {this.props.t("PMCashPayment.received")}
                          </span>
                          <span className={styles.detailsText}>
                            {CapitalizeText(
                              this.props.customerReservation
                                .finalPaymentConfirmedData.dealerActionUserId
                            )}
                          </span>
                        </>
                      }
                    />
                  )}
                </div>
              </div>
            </>
          )}
        </div>
        <RegistrationNumberDialog
          {...this.props}
          open={this.state.openRegistrationNumberDialog}
          close={this.handleRegistrationNumberDialog}
          saveRegistrationData={this.saveRegistrationData}
          maxDate={UiDateUtils.addMonths(6)}
          minDate={UiDateUtils.addDays(-60)}
          fromNscDealerSearch={this.props.fromNscDealerSearch}
        />
        <TermsDialog
          open={this.state.openDealerInvoiceDialog}
          forAll={false}
          dialogBody={this.props.t("PMDealerInvoice.dialogDescription")}
          dialogTitle={this.props.t("PMDealerInvoice.dialogHeader")}
          saveText={this.props.t("PMDealerInvoice.upload")}
          currentDealerId="this.selectedDealer"
          confirmAction={this.uploadInvoice}
          onClose={this.handleDealerInvoiceDialog}
        />
        {/* Delivery Certificate Dialog box */}
        <TermsDialog
          open={this.state.openDeliveryCertificateDialog}
          forAll={false}
          dialogBody={this.props.t("PMDeliveryCertificate.dialogDescription")}
          dialogTitle={this.props.t("PMDeliveryCertificate.dialogHeader")}
          saveText={this.props.t("PMDeliveryCertificate.upload")}
          currentDealerId="this.selectedDealer"
          confirmAction={this.uploadDeliveryCertificate}
          onClose={this.toggleDeliveryCertificateDialog}
        />
        <CheckBoxDialog
          open={this.state.openPaymentWindow}
          title={this.props.t("PMOpenPaymentWindow.financeDialogHeader")}
          text={this.props.t("PMOpenPaymentWindow.dialogDescription")}
          checkboxLabel={this.props.t("PMOpenPaymentWindow.checkboxLabel")}
          onConfirm={this.onConfirmFinancePaymentWindow}
          onClose={this.openPaymentWindow}
          cancelText={this.props.t("PMOpenPaymentWindow.cancel")}
          confirmText={this.props.t("PMOpenPaymentWindow.confirm")}
        />
      </div>
    );
  }
}

export default withTranslation("emp")(FinanceOptions);
